import MicroprogrammingGroupsReport from "./MicroprogrammingGroupsReport";
export default MicroprogrammingGroupsReport;
